import React, { useContext, useState, useRef, useEffect } from "react";

import { ThemeContext } from "../context/Themes";
import { SidebarContext } from "../context/Sidebar";
import { TranslatorContext } from "../context/Translator";

import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import orders from "../assets/data/orders.json";
import messages from "../assets/data/messages.json";
import languages from "../assets/data/languages.json";
import notifications from "../assets/data/notifications.json";

export default function HeaderLayout() {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const { sidebar, toggleSidebar } = useContext(SidebarContext);
  const { t, n, c, changeLanguage, currentLanguage } =
    useContext(TranslatorContext);

  const [getUserDta, setGetUserDta] = useState({});

  const searchRef = useRef();

  useEffect(() => {
    Get_User();
  }, []);

  const [scroll, setScroll] = useState("fixed");
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  window.addEventListener("scroll", () => {
    if (window.scrollY > 0) setScroll("sticky");
    else setScroll("fixed");
  });

  document.addEventListener("mousedown", (event) => {
    if (!searchRef.current?.contains(event.target)) {
      setSearch("");
    }
  });

  const handleLogout = () => {
    localStorage.removeItem("jwt");
    // navigate("");
    window.location.replace("https://bosspanda.io");
  };

  const Get_User = () => {
    try {
      let getdTA = localStorage.getItem("jwt");
      let parseIT = JSON.parse(getdTA);

      setGetUserDta(parseIT);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <header className={`mc-header ${scroll}`}>
      <Link to="/" className="mc-logo-group">
        <img src="/images/logo.png" alt="logo" />
        <span>BossPanda</span>
      </Link>
      <div className="mc-header-group">
        <div className="mc-header-left">
          <button
            type="button"
            className="mc-header-icon search"
            onClick={() => setSearch("show")}
          >
            <i className="material-icons">search</i>
          </button>
          <button
            type="button"
            className="mc-header-icon toggle"
            onClick={toggleSidebar}
          >
            <i className="material-icons">{sidebar ? "menu_open" : "menu"}</i>
          </button>
        </div>

        <div className="mc-header-right">
          <Dropdown className="mc-header-user">
            <Dropdown.Toggle className="mc-dropdown-toggle">
              <Link to="#" className="mc-round-avatar xs">
                <img src="/images/logo.png" alt="avatar" />
              </Link>
              <div className="mc-duel-text xs">
                <h3 className="mc-duel-text-title">
                  {getUserDta?.name} {getUserDta?.last_name}
                </h3>
                <p className="mc-duel-text-descrip">{getUserDta?.reg_em}</p>
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu align="end" className="mc-dropdown-paper">
              <Link to="/my-account" className="mc-dropdown-menu">
                <i className="material-icons">person</i>
                <span>{t("my_account")}</span>
              </Link>
              {/* <Link to='/forgot-password' className='mc-dropdown-menu'><i className='material-icons'>privacy_tip</i><span>{t('reset_password')}</span></Link> */}
              <div
                style={{ cursor: "pointer" }}
                onClick={handleLogout}
                className="mc-dropdown-menu"
              >
                <i className="material-icons">lock</i>
                <span>{t("logout")}</span>
              </div>
            </Dropdown.Menu>
          </Dropdown>
          {/*================================
                            PROFILE PART END
                    ================================*/}
        </div>
      </div>
    </header>
  );
}
